module.exports = __webpack_public_path__ + "img/addressicon.7875f6b6.png";